// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6901d3e1","455":"6a51dd3e","977":"62a56f04"}[chunkId] + ".chunk.js";
};